import { type ComponentProps, forwardRef, ReactNode } from 'react'
import cl from 'clsx'

import classes from './LabeledInput.module.scss'

export type LabeledInputProps = ComponentProps<'input'> & {
    label?: string
    hint?: ReactNode
    error?: string | boolean
    // enterDoesBlur?: boolean
    // PrefixIcon?: ComponentType<ComponentPropsWithRef<'svg'>>
    // suffixNode?: ReactNode
}

export const LabeledInput = forwardRef<HTMLInputElement, LabeledInputProps>(
    function LabeledInput({ className, label, hint, error, ...rest }, ref) {
        return (
            <div className={cl(classes.root, className)}>
                <label className={classes.label}>
                    {label && <div className={classes.labelText}>{label}</div>}
                    <input
                        className={cl(classes.input, {
                            [classes.error]: error,
                        })}
                        ref={ref}
                        {...rest}
                    />
                </label>
                {hint && <div className={classes.hint}>{hint}</div>}
                <div
                    className={cl(classes.errorMessage, {
                        [classes.error]: error,
                    })}
                >
                    {error ? error : '&nbsp;'}
                </div>
            </div>
        )
    }
)
